<a routerLink="/">
	<div class="flex items-center gap-2">
		<img
			[ngSrc]="symbol"
			priority
			width="35"
			height="32"
			alt="orange symbol of the letter r" />
			<div class="flex flex-col">
				<div class="text-rdus-blue-500 dark:text-surface-0 font-semibold text-2xl whitespace-nowrap leading-none">radius auto</div>
				<div class="text-surface-800 dark:text-surface-0 font-semibold text-[10px] whitespace-nowrap leading-none">powered by Pick-n-Pull</div>
			</div>
	</div>
</a>
